import React, { useState } from "react";
import { Box } from "@mui/material";

interface LogoProps {
  src: string | undefined;
  alt: string;
  ticker: string;
  companyName?: string | null;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({
  src,
  alt,
  ticker,
  companyName,
  size = 40,
}) => {
  const [failedSrc, setFailedSrc] = useState<string>();
  const initial =
    companyName?.trim()[0]?.toUpperCase() ??
    ticker?.trim()[0]?.toUpperCase() ??
    "?";

  if (!src || failedSrc === src) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          fontSize: size * 0.4,
          fontWeight: 700,
          color: "#22c55e",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(34, 197, 94, 0.1)"
              : "rgba(34, 197, 94, 0.05)",
          border: (theme) =>
            theme.palette.mode === "dark"
              ? "1px solid rgba(34, 197, 94, 0.2)"
              : "1px solid rgba(34, 197, 94, 0.1)",
          borderRadius: 1,
        }}
      >
        {initial}
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      sx={{
        width: size,
        height: size,
        objectFit: "contain",
      }}
      onError={() => setFailedSrc(src)}
    />
  );
};

export default Logo;
